// extracted by mini-css-extract-plugin
export default {"txt-notfound":"StoreDetailsPage_txt-notfound__uhcye","SearchContainer":"StoreDetailsPage_SearchContainer__EMMTt"};